import React from "react";
import DashboardLayout from "../../layouts/Dashboard";
import {Typography} from "@mui/material";
import ReportCRUDTable from "../../components/CRUD/Tables/ReportCRUDTable";

const IQLSReports = () => {
    return (
        <DashboardLayout>
            <Typography variant="h4" component="h1" gutterBottom>
                IQLS - Отчеты по оценке качества работы лабораторий
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
                Управление отчетами об оценке качества работы лабораторий. Создание, редактирование и просмотр отчетов.
            </Typography>
            <ReportCRUDTable />
        </DashboardLayout>
    );
};

export default IQLSReports;
